const DEFAULT_VOLUME_LOADER_SCHEME = 'cornerstoneStreamingImageVolume';
const DYNAMIC_VOLUME_LOADER_SCHEME = 'cornerstoneStreamingDynamicImageVolume';

export { DEFAULT_VOLUME_LOADER_SCHEME, DYNAMIC_VOLUME_LOADER_SCHEME };
